<template>
  <CModal title="Tambah Soal" :show.sync="showModal" size="lg">
    <vue-editor v-model="data.content" />
    <template #footer>
      <CButton @click="batal" color="danger">Batal</CButton>
      <CButton @click="save" color="success">Simpan</CButton>
    </template>
  </CModal>
</template>
<script>
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
  },
  data() {
    return {
    };
  },
  created() {
    
  },
  props: ["showModal", "data"],
  methods: {
    save() {
      this.$emit("save", this.data);
      this.$emit("cancel");
    },
    batal() {
      this.$emit("cancel");
    },
  },
};
</script>